import React from "react";
import styled from "styled-components";

import { Box, Row, Text, Img, Button } from "../../comps";
import { Theme } from "../../theme/theme-provider";
import { faExchangeAlt } from "@fortawesome/free-solid-svg-icons";

const GridItem = styled(Box)`
  height: 90px;
  width: 100%;
`;

const SongWrapper = styled(Row)`
  width: 100%;
  height: 100%;
  align-items: center;
  margin: 5px;
  padding-left: 40px;
  padding-right: 40px;
  @media ${({ theme }) => theme.screenSize.portrait} {
    padding-left: 10px;
    padding-right: 10px;
  }
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_1};
  &:hover {
    background: #45413d;
  }
`;

export default ({ item, convert }) => {
  const { name, artist, spotifyThumbnail } = item;

  return (
    <GridItem className={"item"}>
      <div class="item-content">
        <SongWrapper>
          <Img width={72} height={72} src={spotifyThumbnail[1]} />
          <Text
            oneline={true}
            fontSize={"16px"}
            fontWeight={300}
            marginLeft={"6%"}
          >
            {name}
          </Text>
          <Text
            oneline={true}
            fontSize={"16px"}
            fontWeight={300}
            marginLeft={"8px"}
            // marginRight={"5%"}
            color={Theme.color.BLUE_4}
          >
            {" by " + artist}
          </Text>
          <Button
            width=""
            height="40px"
            buttonTextColor={Theme.textColor.light}
            buttonBackground={Theme.color.BLACK_1}
            buttonName="Convert"
            buttonIcon={faExchangeAlt}
            buttonFontSize="14px"
            borderRadius={5}
            marginLeft="auto"
            onClick={convert}
          />
        </SongWrapper>
      </div>
    </GridItem>
  );
};
